import { Customer } from './customer';
import { Agency } from './agency';

export class ReservationSearchModel {
    constructor(obj: ReservationSearchModel = {} as ReservationSearchModel) {
        Object.assign(this, obj);
    }

    name?: string;
    customerId?: string;
    agencyId?: string;
    startDate?: Date;
    endDate?: Date;
    customerName?: string;
    agencyName?: string;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/reservationSearchModel.ts